<template>
<div>
    <video class="border-999" controls="controls" preload="auto" :poster="imgUrl" playsinline="true" x5-video-orientation="portraint" :src="url" height="auto" :width="videoSize"></video>
</div>
</template>
<style>
</style>

<script>
import Vue from 'vue'
import config from '@/config.js';
import {
    mapGetters
} from "vuex";
export default {
    data() {
        return {
            url: "https://files.iob.fi/2020/11/1605670820443-c2117758d60052fc906b04b7d0fcb39a-iob.fi-Track-Record.mp4",
            imgUrl: "https://files.iob.fi/2020/11/1605670827445--iob.fi-Track-Record.webp"
        }
    },
    created() {

    },
    mounted() {

    },
    computed: {
        ...mapGetters(["responsive"]),
        videoSize() {
            // responsive == 'PC' ? 849 : 300
            switch (this.responsive) {
                case "PC":
                    return 849;
                case "mobile":
                    return document.body.clientWidth;
                case "pad":
                    return 649;
                default:
                    return 849;
            }
        }
    },
    watch: {

    },
    methods: {

    },
}
</script>
